import { T } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';
import { BearingInputState } from './bearing.input.state';
import { CSS, Style } from './bearing.input.style';
import { Input } from './input';
import { Unit } from './unit';

addStyles(Style);

export const BearingInput = {
	view(state: BearingInputState): MithrilVNode {
		return m('div', { className: CSS.container }, [Input.view(state), Unit.view(T.UNIT_SHORT_DEGREE)]);
	},
};
